function convertDate(dateString) {
  if (!dateString) {
    return ''
  }

  const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토']

  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const dayOfWeek = daysOfWeek[date.getDay()]
  const hours = date.getHours()
  const minutes = date.getMinutes()

  const period = hours < 12 ? '오전' : '오후'
  const formattedHours = hours % 12 || 12
  const formattedMinutes = minutes === 0 ? '' : `${minutes}분`

  return `${year}년 ${month}월 ${day}일 (${dayOfWeek}) ${period} ${formattedHours}시 ${formattedMinutes}`
}

export function formatDateRange(startDateString, endDateString) {
  if (!startDateString || !endDateString) {
    return ''
  }

  const startDateTime = new Date(startDateString)
  const endDateTime = new Date(endDateString)

  const startYear = startDateTime.getFullYear()
  const startMonth = startDateTime.getMonth() + 1
  const startDay = startDateTime.getDate()

  const endYear = endDateTime.getFullYear()
  const endMonth = endDateTime.getMonth() + 1
  const endDay = endDateTime.getDate()

  if (startYear === endYear && startMonth === endMonth && startDay === endDay) {
    const startPeriod = startDateTime.getHours() < 12 ? '오전' : '오후'
    const startFormattedHours = startDateTime.getHours() % 12 || 12
    const startMinutes = startDateTime.getMinutes()

    const endPeriod = endDateTime.getHours() < 12 ? '오전' : '오후'
    const endFormattedHours = endDateTime.getHours() % 12 || 12
    const endMinutes = endDateTime.getMinutes()

    const startFormattedMinutes = startMinutes === 0 ? '' : `${startMinutes}분`
    const endFormattedMinutes = endMinutes === 0 ? '' : `${endMinutes}분`

    return `${startYear}년 ${startMonth}월 ${startDay}일 ${
      convertDate(startDateString).split(' ')[3]
    } ${startPeriod} ${startFormattedHours}시 ${startFormattedMinutes} ~ ${endPeriod} ${endFormattedHours}시 ${endFormattedMinutes}`
  }

  return `<div>${convertDate(startDateString)}</div>
  <div>~</div>
  <div>${convertDate(endDateString)}</div>`
}
